import log from 'salvo-lite/log'
import axios from 'axios'

class Variants {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._variants = elem.querySelectorAll('[data-variant]')
        this._input = document.querySelector('input[name="id"]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._variants.forEach(variant => {
            variant.addEventListener('click', e => {
                this._updateContent(variant.getAttribute('data-variant'))
                this._updateUrl(variant.getAttribute('data-variant'))
            })
        })
        this._elem.addEventListener('change', e => {
            this._updateContent(this._elem.value)
            this._updateUrl(this._elem.value)
        })
    }
    _updateContent (id) {
        this._input.value = id
        axios.get(window.location.pathname + '?variant=' + id).then((response) => {
            const productPageContent = document.createElement('div')
            productPageContent.innerHTML = response.data
            const newVariantList = productPageContent.querySelector('.product__variants').innerHTML
            const newPrice = productPageContent.querySelector('.product-price').innerHTML
            const ctaAttribute = productPageContent.querySelector('.product__cta').getAttribute('data-add-to-cart')
            const ctaText = productPageContent.querySelector('.product__cta').innerHTML
            const sticky = productPageContent.querySelector('.product__sticky-atc').innerHTML
            const wishlist = productPageContent.querySelector('.product__wishlist').innerHTML
            this._updatePrice(newPrice)
            this._updateVariantList(newVariantList)
            this._updateCTA(ctaAttribute, ctaText)
            this._updateSticky(sticky)
            this._updateWishlist(wishlist)
        }).then((response) => {
            const forms = document.querySelectorAll('form.product-form')
            forms.forEach(form => {
                this._theme.registerComponents(form)
            })
        })
    }
    _updateWishlist (wishlist) {
        document.querySelector('.product__wishlist').innerHTML = wishlist
    }
    _updateSticky (sticky) {
        document.querySelector('.product__sticky-atc').innerHTML = sticky
    }
    _updatePrice (price) {
        document.querySelector('.product-price').innerHTML = price
    }
    _updateVariantList (content) {
        document.querySelector('.product__variants').innerHTML = content
    }
    _updateCTA (att, txt) {
        document.querySelector('.product__cta').setAttribute('data-add-to-cart', att)
        document.querySelector('.product__cta').innerHTML = txt
    }
    _updateUrl (id) {
        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + id
        window.history.replaceState({ path: newurl }, '', newurl)
    }
}

export default Variants



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variants.js